"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModals = exports.useModal = void 0;
const react_1 = require("react");
function useModal() {
    const [{ isOpen, data }, setModalState] = react_1.useState({
        isOpen: false,
    });
    const open = react_1.useCallback((data) => {
        setModalState({ isOpen: true, data });
    }, [setModalState]);
    const close = react_1.useCallback(() => {
        setModalState({ isOpen: false, data: undefined });
    }, [setModalState]);
    return {
        isOpen,
        data,
        open,
        close,
    };
}
exports.useModal = useModal;
function useModals(modalNames) {
    const [modalState, setModalState] = react_1.useState(modalNames.reduce((acc, modalName) => (Object.assign(Object.assign({}, acc), { [modalName]: { isOpen: false } })), {}));
    const open = (modalName) => (data) => setModalState((oldState) => (Object.assign(Object.assign({}, oldState), { [modalName]: { isOpen: true, data } })));
    const close = (modalName) => () => setModalState((oldState) => (Object.assign(Object.assign({}, oldState), { [modalName]: { isOpen: false } })));
    return modalNames.reduce((acc, modalName) => (Object.assign(Object.assign({}, acc), { [modalName]: {
            isOpen: modalState[modalName].isOpen,
            data: modalState[modalName].data,
            open: open(modalName),
            close: close(modalName),
        } })), {});
}
exports.useModals = useModals;
//# sourceMappingURL=modal.js.map